import tw, { styled } from "twin.macro";

export const ButtonSection = styled.button(({ theme }) => [
  tw`flex justify-center items-center rounded-full w-[11.25rem] h-[11.25rem]`,
  `background: rgba(29, 29, 29, 0.8);`,
  `border: 3px solid #414141;`,
  `box-shadow: 6px 12px 48px rgba(0, 0, 0, 0.16);`
]);
